import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';

export const fetchSalesRegisterList = async ({ userId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getall`, {
    params: { UserId: userId, IsForDropodown: '0' }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const fetchSalesRegisterById = async ({ salesRegisterId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getbyid`, {
    params: { SalesRegisterId: salesRegisterId }
  });
  return response?.data?.data ?? { header: null, details: [] };
};

export const saveSalesRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/save`, payload);
  return response?.data;
};

export const deleteSalesRegister = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/delete`, payload);
  return response?.data;
};

export const fetchSalesPendingPaymentList = async ({ userId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getPendingPaymentList`, {
    params: { UserId: userId }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const saveSalesPaymentReceipt = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/savePaymentReceipt`, payload);
  return response?.data;
};

export const fetchSalesPaymentFollowupById = async ({ userId, salesRegisterId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getPaymentFollowupById`, {
    params: { UserId: userId, SalesRegisterId: salesRegisterId }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const saveSalesPaymentFollowup = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/savePaymentFollowup`, payload);
  return response?.data;
};

export const updateSalesPaymentFollowup = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/updatePaymentFollowup`, payload);
  return response?.data;
};

export const deleteSalesPaymentFollowup = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/deletePaymentFollowup`, payload);
  return response?.data;
};

export const fetchSalesPaymentReceiptHistory = async ({ userId, salesRegisterId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/salesregister/getPaymentReceiptHistoryById`, {
    params: { UserId: userId, SalesRegisterId: salesRegisterId }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : Array.isArray(rows?.[0]) ? rows[0] : [];
};

export const updateSalesPaymentReceipt = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/updatePaymentReceipt`, payload);
  return response?.data;
};

export const deleteSalesPaymentReceipt = async (payload) => {
  const response = await axios.post(`${getApiBaseUrl()}/salesregister/deletePaymentReceipt`, payload);
  return response?.data;
};
